export const THREAD_LOAD_LIMIT = 15

export const EVENTBUS_CONTEXT = 'chat'
export const EVENTBUS_COMMAND_BASE = 'base'
